
import axios from "axios";
import { store } from '../store';
import {i18n} from "../i18n";

export const nominateService = {
    nominate
};

function nominate(organisationName, contactName, contactPhone, contactEmail, message, recaptchaToken, brand) {

    const instance = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        timeout: 10000
    });

    return instance
        .post(process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST + '/api/nominates/send', {
            organisation_name : organisationName,
            contact_name: contactName,
            contact_email: contactEmail,
            contact_phone: contactPhone,
            message: message,
            recaptchaToken: recaptchaToken,
            brand: brand
        })
        .then(response => {

            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return Promise.reject('unsuccessful');
            }
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return Promise.reject(error);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // rejected
                return Promise.reject(error);
            }
        });
}
